module.exports = __webpack_public_path__ + "img/guanyuwomen.d3b61ed0.png";